import { styled } from "../../styled-components";
import Img from "../smart/img/img";
import { initialsFontColor, initialsBackground } from "../../lib/theme/theme";

export const GridItemTitleStyle = styled.div`
    color: ${p => p.theme.fgColorDark};
    ${p => p.theme.gridItem.title.fontStyle};
    margin: 4px 0 0 0;
`;

export const GridItemSubtitleStyle = styled.div`
    color: ${p => p.theme.fgColorMedium};
    ${p => p.theme.gridItem.subtitle.fontStyle};
`;

export const GridItemStyle = styled.div`
    margin: 0 ${p => p.theme.pageMarginMedium}px ${p => p.theme.pageMarginMedium}px;
    &:hover {
        cursor: pointer;
    }
`;

export const GridImageWrapper = styled.div<{ height: number; width: number }>`
    position: relative;
    height: ${p => p.height}px;
    width: ${p => p.width}px;
`;

export const GridItemImageStyle = styled(Img)`
    background-color: ${p => p.theme.skeletonColor};
    object-fit: cover;
    border-radius: 6px;

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    // Emoji
    font-size: 50px;
`;

export const GridItemInitials = styled.div`
    border-radius: 6px;

    background-color: ${p => initialsBackground(p.theme)};
    color: ${p => initialsFontColor(p.theme)};

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 20px;

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const InitialsText = styled.div`
    font-size: 34px;
    text-align: center;
    font-weight: bold;

    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
`;
